// prettier-ignore
module.exports = {
  GEN_ROLLOUT_COOKIE_NAME: 'flip_genv1'
};
